import { Input } from "@frui.ts/bootstrap";
import { observer } from "mobx-react-lite";
import React from "react";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { translateGeneral } from "utils/localizations";
import BankTransferListViewModel from "viewModels/finance/bankExports/bankTransfers/bankTransferListViewModel";
import AdvancedSelect from "@edaz/edazkit/controls/AdvancedSelect";
import FilterView from "../../common/filter";
import DateRangeInputControl from "controls/dateRangeInput";
import type BankExportListViewModel from "../../../viewModels/finance/bankExports/bankExportListViewModel";
import type { IBankExport } from "../../../entities/bankExport";

export interface BankExportFiltersProps<TEntity extends IBankExport> {
  vm: BankExportListViewModel<TEntity>;
}

function BankExportFilters<TEntity extends IBankExport>(props: BankExportFiltersProps<TEntity>) {
  const { vm } = props;

  return (
    <FilterView vm={vm}>
      <div className="row">
        <Form.Group as={Col} md={6} lg={4} xl={3}>
          <Form.Label>{vm.translateAttribute("name")}</Form.Label>
          <Input target={vm.filter} property="exportName" placeholder={translateGeneral("search")} />
        </Form.Group>
        {vm instanceof BankTransferListViewModel && (
          <Form.Group as={Col} md={6} lg={4} xl={3}>
            <Form.Label>{vm.translateAttribute("refundType")}</Form.Label>
            <AdvancedSelect
              target={vm.filter}
              property="refundType"
              items={vm.stateOptions}
              placeholder={translateGeneral("select")}
            />
          </Form.Group>
        )}
        <Form.Group as={Col} lg={8} xl={6}>
          <Form.Label>{vm.translateAttribute("createdAt")}</Form.Label>
          <DateRangeInputControl target={vm.filter} property="createdDate" />
        </Form.Group>
      </div>
    </FilterView>
  );
}

export default observer(BankExportFilters);
